import { Modal, Text } from '@fozito/common-ui';
import { Form, Input } from 'antd';
import { FormInstance } from 'antd/lib';
import { DollarAmountInputRef } from 'modules/POS/Cashier/components/DollarAmount/helpers';
import DollarAmountInput from 'modules/POS/Cashier/components/DollarAmount/Input';
import DollarAmountKeyboard from 'modules/POS/Cashier/components/DollarAmount/Keyboard';
import styled from 'styled-components';

type QuickPayV2Props = {
  visible: boolean;
  onClose: () => void;
  onSubmit: (value: { amount: number, serviceName: string }) => void;
  inputRef?: React.RefObject<DollarAmountInputRef>;
  onIssueGiftCard?: () => void;
  form: FormInstance<any>;
};
const ModalAddPrice = ({ form, visible, onClose, onSubmit, inputRef, onIssueGiftCard }: QuickPayV2Props) => {
  const onClear = () => form.resetFields(['amount']);
  return (
    <Modal
      open={visible}
      title='ADD PRICE'
      footer={null}
      width={'1200px'}
    >
      <Container onFinish={onSubmit as any} form={form} initialValues={{ amount: 0, serviceName: 'Quick Pay' }}>
        <ServiceName className='ServiceName'>
          <Text content_content_2_16_medium color_text_3 text_center style={{ fontSize: 20 }}>
            Service Name:
          </Text>
          <Form.Item noStyle name={'serviceName'}>
            <Input className='service-name-input' size='small' />
          </Form.Item>
        </ServiceName>
        <Text content_content_2_16_medium color_text_3 text_center style={{ fontSize: 20 }}>
          Enter Amount:
        </Text>
        <Form.Item noStyle name={'amount'}>
          <DollarAmountInput
            ref={inputRef}
            className='CurrencyInput'
            inputMode='none'
            autoFocus
            color='#D2464F'
            maxValue={1000}
          />
        </Form.Item>
        <Form.Item noStyle name={'amount'}>
          <DollarAmountKeyboard
            controlRef={inputRef}
            maxValue={1000}
          />
        </Form.Item>
        <div className="footer-container">
          <button onClick={onIssueGiftCard} type='button' className="btn btn-issue-gift-card"><span>Issue Gift Card</span></button>
          <button onClick={onClear} type='button' className="btn btn-clear"><span>Clear</span></button>
          <button onClick={onClose} type='button' className="btn btn-close"><span>Close</span></button>
          <button type='submit' className="btn btn-done"><span>Ok</span></button>
        </div>
      </Container>
    </Modal >
  );
};
export default ModalAddPrice;
const ServiceName = styled.div`
  margin-bottom: 1.5rem;
`;
const Container = styled(Form)`
.header-container {
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  background: #232F3E;
  span {
    color: #FFF;
    text-align: center;
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
}
.modal-label {
  color: #64748B;
  text-align: center;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.ServiceName {
  padding-top: 24px;
}
.ant-input.service-name-input {
  color: #1D2129;
  text-align: center;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  text-transform: capitalize;
  border: none;
  outline: none;
}

.CurrencyInput {
  justify-content: center;
  margin-bottom: 16px;
  input {
    border: none;
    box-shadow: none;
    text-align: center;
  }
  .fake-labels, input, .mock-cursor  {
    font-size: 50px;
    font-weight: 600;
  }
}

.footer-container {
  display: flex;
  padding: 0px 16px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  padding-bottom: 40px;
  button.btn {
    display: flex;
    height: 70px;
    padding: 16px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    border-radius: 4px;
    background: #E5E6EB;
    box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #D6D6E7 inset;
    span {
      color: #1D2129;
      text-align: center;
      font-family: Poppins;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    &.btn-issue-gift-card {
      border-radius: 4px;
      background: #C6E9EF;
      box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #6FABB6 inset;
    }
    &.btn-clear {
      border-radius: 4px;
      background: #C6E9EF;
      box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #6FABB6 inset;
    }

    &.btn-clear {
      border-radius: 4px;
      background: #FCFCFD;
      box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #D6D6E7 inset;
    }

    &.btn-done {
      border-radius: 4px;
      background: #FF8890;
      box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -4px 0px 0px #E7646D inset;
    }
  }
}
`;
